import React, { useContext, useEffect, useState } from 'react';
import { Flex, Text } from '@chakra-ui/layout';
import { Heading, Spinner } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/icon';
import { MdOutlineRoute, MdArrowBack, MdOutlineLayers, MdChevronRight, MdMoreVert, MdMoreHoriz } from 'react-icons/md';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import ExperienceGroupInPersonaNameForm from './ExperienceGroupInPersonaNameForm';
import ExperiencesInPersonaListMenu from './experiencesInPersonaListMenu';
import { PersonaContext } from '../../lib/personaContext';
import { PersonaPageContext } from '../lib/personaPageContext';
import { useNavigate } from 'react-router-dom';
export default function ExperiencesInPersonaListHeader(props) {
  const {
    persona,
    rights,
  } = useContext(PersonaContext);
  const {
    experienceList,
    experienceGroupList,
    sharedExperienceList,
    group,
    parentGroup,
    refreshSharedExperienceList
  } = useContext(PersonaPageContext);
  const {refreshList} = props;
  const [goingBack, setGoingBack] = useState(false);
  const navigate = useNavigate();
  const goBack = async () => {
    try {
      setGoingBack(true);
      await refreshList();
      setGoingBack(false);
      if(group?.group.persona_experience_group_id) {
        navigate(`/persona/${persona.id}?group-id=${group.group.persona_experience_group_id}`);
      } else {
        navigate(`/persona/${persona.id}`);
      }
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <Flex
      alignItems='center'
      py={2}
      px={3}
      backgroundColor="white"
      justifyContent={"space-between"}
      h={"54px"}
    >
        <>
          <Flex
            alignItems={"center"}
          >
            <Flex mr={3} alignItems='center' >
              {goingBack && (
                <Flex mr={3}>
                  <Spinner />
                </Flex>
              )}
              {(!goingBack && group) && (
                <Icon
                  as={MdArrowBack}
                  boxSize="18px"
                  mr={3}
                  cursor={"pointer"}
                  onClick={goBack}
                />
              )}
              <Flex mr={2} alignItems='center'
              cursor={"pointer"}
              onClick={() => {
                navigate(`/persona/${persona.id}`);
              }}
              >
                <Icon
                  as={MdOutlineRoute}
                  boxSize="18"
                  mr={2}
                />
                <Heading variant="secondary" >Experiences</Heading>
                {group && (
                  <Icon
                  as={MdChevronRight}
                  boxSize="14px"
                  ml={2}
                  color="text.medium.grey"
                />
                )}
            </Flex>
            {group && 
              <Icon
              as={MdOutlineLayers}
              color="text.medium.blue"
              boxSize="18"
              mr={2}
              />
            }
              {parentGroup && (
                <>
                {parentGroup.group_id && (
                  <>
                  <Flex
                  cursor={"pointer"}
                    onClick={() => {
                      navigate('/persona/' + persona.id + '?group-id=' + parentGroup.group_id)
                     }}
                  >
                    <Icon
                      as={MdMoreHoriz}
                      boxSize="18px"
                      mr={2}
                      color="text.light.blue"
                      mt="10px"
                    />
                  </Flex>
                  <Icon
                    as={MdChevronRight}
                    boxSize="14px"
                    mr={2}
                    color="text.light.blue"
                  />
                  </>
                )}
                <Text
                  color="text.light.blue"
                  fontWeight={"500"}
                  fontSize={"14px"}
                   mr={2}
                   maxWidth={"150px"}
                   textOverflow={"ellipsis"}
                   whiteSpace={"nowrap"}
                   cursor={"pointer"}
                   onClick={() => {
                    navigate('/persona/' + persona.id + '?group-id=' + parentGroup.id)
                   }}
                >{parentGroup.group.name}</Text>
                <Icon
                  as={MdChevronRight}
                  boxSize="14px"
                  mr={2}
                  color="text.light.blue"
                />
                </>
              )}
              <InlineFormWrapper
                width={"100%"}
                canEdit={rights?.can_update}
                value={
                <Text
                fontSize={"18px"}
                color="text.medium.blue">{group?.group?.name}</Text>}
              >
                {(close) => (
                  <Flex pr={3}>
                    <ExperienceGroupInPersonaNameForm
                      groupId={group.id}
                      group={group?.group}
                      onSubmitted={close}
                      onCancel={close}
                    />
                  </Flex>
                )}
              </InlineFormWrapper>
            </Flex>
            {rights?.can_update &&
              <ExperiencesInPersonaListMenu
                hasExperiences={!!(experienceList?.length || experienceGroupList?.length || sharedExperienceList?.length)}
                group={group}
                            onNew={async () => {
              if (refreshList) {
                await refreshList();
              }
              if (refreshSharedExperienceList && typeof refreshSharedExperienceList === 'function') {
                await refreshSharedExperienceList();
              }
            }}
              />
            }
          </Flex>
        </>
    </Flex>
  );
}
